<script setup>
import { ref } from 'vue';
import LabelManagerPopup from './LabelManagerPopup.vue';
import LabelFormDialog from './LabelFormDialog.vue';

// Reusable label manager: the Workspace/Personal labels popup + the create/edit
// form, used both from the Omni inbox "+" and the conversation "Add labels".
const show = defineModel('show', { type: Boolean, default: false });

const showLabelForm = ref(false);
const editingLabel = ref(null);

function onCreate() {
  show.value = false;
  editingLabel.value = null;
  showLabelForm.value = true;
}

function onEdit(label) {
  show.value = false;
  editingLabel.value = label;
  showLabelForm.value = true;
}

function closeForm() {
  showLabelForm.value = false;
  editingLabel.value = null;
}
</script>

<template>
  <woot-modal
    v-model:show="show"
    size="!w-[441px]"
    :on-close="() => (show = false)"
  >
    <LabelManagerPopup
      @create="onCreate"
      @edit="onEdit"
      @close="show = false"
    />
  </woot-modal>
  <woot-modal
    v-model:show="showLabelForm"
    size="!w-[460px]"
    :on-close="closeForm"
  >
    <LabelFormDialog :label="editingLabel" @close="closeForm" />
  </woot-modal>
</template>
